import { ARRAY_ERROR } from 'final-form';

import { REQUIRED_ERROR } from 'CorePackage/MainModule/constants/validationErrors';
import { makeRequired } from 'CorePackage/MainModule/validators/isRequired';
import { ISelectOption } from 'UIPackage/MainModule/components/SelectInput';

import { IKnmActFamiliarizationNotificationsForm } from '../interfaces/IKnmActFamiliarizationNotificationsForm';
import { ISignersForm } from '../interfaces/ISignersForm';
import { isFamiliarizationNotificationAddedAfterSigning } from './isFamiliarizationNotificationAddedAfterSigning';

/** Текст ошибки под блоком уведомлений и ARRAY_ERROR для блокировки сохранения. */
export const FAMILIARIZATION_NOTIFICATION_REQUIRED_FOR_NEW_SIGNER_ERROR =
  'При добавлении нового подписанта требуется добавить уведомление';

const hasSignerIdentity = (signer: ISignersForm | undefined): boolean => {
  if (!signer || signer.systemSignature != null) {
    return false;
  }

  if (typeof signer.fioSigner === 'string') {
    return !!signer.fioSigner.trim();
  }

  const fioOption = signer.fioSigner as ISelectOption | undefined;

  return !!(fioOption?.value || fioOption?.label);
};

/**
 * Новый подписант после выписки/подписания: firstExtractDateTime уже есть,
 * а у подписанта нет existedAtSigning (добавлен после подписания).
 */
export const hasNewSignerAfterExtract = (
  signers: ISignersForm[] | undefined,
  firstExtractDateTime: string | null | undefined,
  isUseSigners: boolean,
): boolean => {
  if (!isUseSigners || !firstExtractDateTime) {
    return false;
  }

  return (signers || []).some(signer => !signer?.existedAtSigning && hasSignerIdentity(signer));
};

type FamiliarizationNotificationsValidateResult = (Record<string, string | undefined> | undefined)[] | undefined;

/**
 * Валидация уведомлений: поля записи + обязательность новой записи,
 * если после выписки добавлен новый подписант.
 */
export const getFamiliarizationNotificationsValidate = ({
  familiarizationNotifications,
  signers,
  firstExtractDateTime,
  isUseSigners,
}: {
  familiarizationNotifications: IKnmActFamiliarizationNotificationsForm[] | undefined;
  signers: ISignersForm[] | undefined;
  firstExtractDateTime: string | null | undefined;
  isUseSigners: boolean;
}): FamiliarizationNotificationsValidateResult => {
  const itemErrors = familiarizationNotifications?.map(fn => ({
    knmNoticeType: makeRequired(REQUIRED_ERROR)(fn?.knmNoticeType),
    noticeDate: makeRequired(REQUIRED_ERROR)(fn?.noticeDate),
  }));

  const isNewNotificationRequired =
    hasNewSignerAfterExtract(signers, firstExtractDateTime, isUseSigners) &&
    !familiarizationNotifications?.some(isFamiliarizationNotificationAddedAfterSigning);

  if (!isNewNotificationRequired) {
    return itemErrors;
  }

  const result = (itemErrors || []) as (Record<string, string | undefined> | undefined)[] & {
    [ARRAY_ERROR]?: string;
  };

  result[ARRAY_ERROR] = FAMILIARIZATION_NOTIFICATION_REQUIRED_FOR_NEW_SIGNER_ERROR;

  return result;
};
